/* eslint-disable react/prop-types */
import React, { CSSProperties, Component } from 'react';
import DocsConfig from '@tencent/docs-config';
import PcLeftThumbnailList from '@com/pc-left-thumbnail-list/index';
import ToolbarItemTemplate from '@com/tool-bar/toolbar-item-template';
import ToolbarManager, { SelectElementTypes } from '../../editor/src/js/constants/toolbar-data';
import styles from './left-bar.css';
import { observer } from 'mobx-react';
import { LEFT_BAR_CONTENT_WIDTH } from '../../editor/src/js/constants';
import { PreviewConfig, ToolbarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import { PPTEditorStateType } from '@src/slide/domain/ui-model/constant/edit-state-type';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import eventBus, { EventKeys } from '@src/slide/infrastructure/module/independent/event-emitter/instance';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';

const appConfigInstance = DocsConfig.getInstance();

@observer
class LeftBar extends Component<{ style?: CSSProperties }> {
    private mounted: boolean;
    public constructor(props) {
        super(props);
        this.mounted = false;
    }

    public componentDidMount = () => {
        this.mounted = false;
        this.controlPreLeftBar();
    };

    public render() {
        const defaultTemplates = ToolbarManager.getGroupListByType(SelectElementTypes.TEMPLATE);
        const disabled = this.getUiDataService().presentation.operation.loading === true
        || this.getUserPriviledgeService().pptEditorState !== PPTEditorStateType.EDITABLE;
        const isMasterEditType = this.getMasterLayoutEditService()?.isMasterEditType;
        const showAddSlide = !appConfigInstance.getConfig(PreviewConfig.hideAddSlide) && !isMasterEditType;
        const needShowRecommendLayouts = appConfigInstance.getConfig(ToolbarFileMenuConfig.recommendLayout) ?? true;
        return (
            <div className={styles.leftBar}
                style={{ ...this.props.style }}>
                {showAddSlide && <div style={{
                    width: LEFT_BAR_CONTENT_WIDTH,
                    height: '44px',
                    // padding: '12px 20px',
                    position: 'absolute',
                    userSelect: 'none',
                    WebkitUserSelect: 'none',
                }}>
                    <ToolbarItemTemplate
                        {...defaultTemplates}
                        disabled={disabled}
                        needShowRecommendLayouts={needShowRecommendLayouts}
                        onOnlineClick={() => {
                            this.getImportOnlineFileManager()?.promise()
                                .then(importOnlineFileManager => importOnlineFileManager.show());
                        }}
                    />
                </div>}
                <PcLeftThumbnailList
                    shouldUpdate={!this.mounted}
                    style={showAddSlide ? {} : { marginTop: 14 }}
                    slideListService={this.getSlideListService()}
                />
            </div>
        );
    }

    /**
     * 控制左侧栏的隐藏的时机
     * 优先隐藏第一个 preLeftItem 的原因是因为 firstSlide 是同步转换，会先出
     * 此时如果隐藏侧边栏，会发现从第二个 slide 开始数据还没转换完成，导致画面闪现
     * @returns
     */
    private controlPreLeftBar() {
        const hiddenPreLeftBar = () => {
            const preLeftBar = document.querySelector('.pre-left-bar');
            preLeftBar && ((preLeftBar as HTMLElement).style.display = 'none');
        };

        const slideCount = SlideDataServices.States.SlideCountState()?.slideCount ?? 0;
        if (slideCount === 0) {
            setTimeout(hiddenPreLeftBar, 0);
            return;
        }
        const offEvent = eventBus.on(EventKeys.SLIDE_LIST_CELL_MOUNTED, (slideModel: ISlideModel) => {
            const isFirstSlide = this.getUiDataService().presentation.children.indexOf(slideModel) === 0;
            const preLeftItem = document.querySelectorAll('.pre-slide-list-item')?.[0];
            if (isFirstSlide && preLeftItem) {
                (preLeftItem as HTMLElement).style['background-color'] = 'transparent';
                preLeftItem.getElementsByTagName('img')?.[0]?.remove?.();
            }
            if (!isFirstSlide || slideCount === 1) {
                hiddenPreLeftBar();
                offEvent?.();
            }
        });
    }

    private getUiDataService() {
        return this.getAppServices().getUiDataService();
    }

    private getUserPriviledgeService() {
        return this.getAppServices().viewableServiceLayer.userPriviledgeService;
    }

    private getMasterLayoutEditService() {
        return this.getAppServices().editableServiceLayer?.masterLayoutEditService;
    }

    private getMasterLayoutStyleService() {
        return this.getAppServices().viewableServiceLayer.masterLayoutStyleService;
    }

    private getImportOnlineFileManager() {
        return this.getAppServices().editableServiceLayer?.importOnlineFileManager;
    }

    private getSlideListService() {
        return this.getAppServices().viewableServiceLayer.slideListService;
    }

    private getAppServices() {
        return AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices;
    }
}

export default LeftBar;
